import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { UserContext } from '../components/UserProvider';

// Renders the route only for a signed in user, otherwise sends them to the sign in
// screen and remembers where they were headed so they can be returned there.
//
// While Firebase is still restoring the session on a page refresh, `initializing`
// is true and we render nothing. Redirecting during that window would bounce a
// signed in user out of the app on every refresh.
const PrivateRoute = ({ component: Component, ...rest }) => {

  const { user, initializing } = useContext(UserContext);

  return (
    <Route {...rest} render={props => {

      if (initializing) {
        return null;
      }

      if (user) {
        return <Component {...props} />;
      }

      return (
        <Redirect to={{
          pathname: '/',
          state: { from: props.location }
        }}
        />
      );

    }} />
  );

};

export default PrivateRoute;